module.exports = __webpack_public_path__ + "img/bundlesBackground.fdad7ba2.svg";